import { isEqual } from 'lodash-es';
import type { DependencyList } from 'react';
import { useMemo, useRef } from 'react';

/**
 * Returns the same reference so long as any new reference is equivalent to the
 * previous value.
 */
export function useMemoDeepEqual<T>(factory: () => T, deps: DependencyList): T {
    const lastValue = useRef(factory());

    return useMemo(() => {
        const value = factory();
        if (!isEqual(lastValue.current, value)) {
            lastValue.current = value;
        }
        return lastValue.current;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}

/**
 * Returns the same reference so long as any new reference is equivalent to the
 * previous value.
 */
export function useMemoDeepEqualValue<T>(value: T, deps?: DependencyList): T {
    return useMemoDeepEqual(() => value, deps ?? [value]);
}
